<template>
  <div class="container" style="background:#fff;padding:0px; ">
    <topOp> </topOp>
    <div class="row">
      <div class="col-md-12">
        <div class="horasExtras">
          <h3 style="font-style:italic;font-weight: 700;">
            Custo do Empregado
          </h3>
          <div class="formAjuste" style="margin-top:90px;">
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Regime Tributario:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="fa fa-vcard" style="font-size:16px;color:#808080;"></i></div>
              </div>
              <select @click="regimeTributarioOp()" name="" id="motivoTermino"
                style="width:325px;height:43px;border-top-right-radius: 10px;border-bottom-right-radius: 10px;">
                <option value="0">Selecionar</option>
                <option value="1">Simples Nacional Anexo I, II, III e V</option>
                <option value="2">Simples Nacional, Anexo IV</option>
                <option value="3">Lucro Presumido ou Lucro Real</option>

              </select>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Salário Mensal:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="material-icons"
                    style="font-size:16px;color:#808080;">attach_money</i></div>
              </div>
              <money class="form-control formatacaoInput" v-model="salarioMensal" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Vale Transporte:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="material-icons"
                    style="font-size:16px;color:#808080;">attach_money</i></div>
              </div>
              <money class="form-control formatacaoInput" v-model="valeTrans" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Vale Refeição:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="material-icons"
                    style="font-size:16px;color:#808080;">attach_money</i></div>
              </div>
              <money class="form-control formatacaoInput" v-model="valeRefei" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Plano de Saúde:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="material-icons"
                    style="font-size:16px;color:#808080;">attach_money</i></div>
              </div>
              <money class="form-control formatacaoInput" v-model="planoSaude" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">Outros Beneficios:
            <p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text "><i class="material-icons"
                    style="font-size:16px;color:#808080;">attach_money</i></div>
              </div>
              <money class="form-control formatacaoInput" v-model="outroBene" v-bind="money"
                @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money>
            </div>

            <div id="cnae" v-if="cnae">
              <fieldset>
                <legend>Campos de Preenchimento</legend>
                <div style="display:flex;">
                  <input type="text" placeholder="Digite o CNAE ou Descrição" v-model="txtCnae">
                  <button @click="buscarCnae">
                    <span v-if="!spiner2">
                      Busca
                    </span>
                    <span v-else>
                      <b-spinner v-show="spiner2" style="width: 1.5rem;height: 1.5rem;" small></b-spinner>
                    </span>
                  </button>
                </div>
                <div style="margin-top:15px;">
                  <p v-if="rat">RAT:</p>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text "><i class="fas fa-percentage"
                          style="font-size:16px;color:#808080;"></i></div>
                    </div>
                    <input class="form-control formatacaoInput" v-if="rat" v-model="txtRat" style="height: 35px;">
                  </div>

                  <p v-if="aliquota">Alíquota Terceiros:</p>

                  <div class="input-group" v-if="aliquota">
                    <div class="input-group-prepend">
                      <div class="input-group-text "><i class="fas fa-percentage"
                          style="font-size:16px;color:#808080;"></i></div>
                    </div>
                    <input class="form-control formatacaoInput" v-if="aliquota" v-model="txtAliquota"
                      style="height: 35px;">
                  </div>
                </div>
              </fieldset>
            </div>

            <button class="limpar" @click="limpar()">Limpar</button> <a href="#horasExtrasResultado1"><button
                :disabled="disabled" class="calcular" @click="calcular()">calcular <b-spinner v-show="spiner"
                  style="width: 1.5rem;height: 1.5rem;" small></b-spinner> </button></a>
            <br>
            <br>
            <span style="color:red;" v-show="erro">Erro no cálculo. Por favor revise os campos!</span>
            <br>
          </div>
        </div>
      </div>
    </div>
    <div class="horasExtrasResultado" id="horasExtrasResultado1" style="background:#BEBEBE;">
      <h3 style="font-style:italic;">
        Resultado do Cálculo
      </h3>
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <p class="pResult">Salario:</p>
          <input type="text" class="inputResult" :value="resultadoValorSalario" disabled>
          <p class="pResult"> Vale Transporte:</p>
          <input type="text" class="inputResult" :value="rvaleTransporte" disabled>
          <p class="pResult">Desconto Vale Transporte:</p>
          <input type="text" class="inputResult" :value="rdescontoValeTransporte" disabled>
          <p class="pResult">Vale Refeição:</p>
          <input type="text" class="inputResult" :value="rvaleRefeicao" disabled>
          <p class="pResult">Plano de Saúde:</p>
          <input type="text" class="inputResult" :value="rplanoSaude" disabled>
          <p class="pResult">INSS:</p>
          <input type="text" class="inputResult" :value="rinss" disabled>
          <p class="pResult">INSS 13º e Férias:</p>
          <input type="text" class="inputResult" :value="rinss13Ferias" disabled>
          <p class="pResult" v-show="mostraEncarggo">CPP:</p>
          <input type="text" class="inputResult" v-show="mostraEncarggo" :value="rcpp" disabled>
        </div>
        <div class="col-md-6 col-sm-6">
          <p class="pResult"> Outros Beneficios:</p>
          <input type="text" class="inputResult" :value="outrosBeneficios" disabled>
          <p class="pResult"> 13º Salário:</p>
          <input type="text" class="inputResult" :value="rvalor13Salario" disabled>
          <p class="pResult">Férias:</p>
          <input type="text" class="inputResult" :value="rferias" disabled>
          <p class="pResult">1/3 Férias:</p>
          <input type="text" class="inputResult" :value="rumTercoFerias" disabled>
          <p class="pResult">FGTS:</p>
          <input type="text" class="inputResult" :value="rfgts" disabled>
          <p class="pResult">FGTS 13º e Férias:</p>
          <input type="text" class="inputResult" :value="rfgts13Ferias" disabled>
          <p class="pResult" v-show="mostraEncarggo">RAT:</p>
          <input type="text" class="inputResult" :value="rrat" disabled v-show="mostraEncarggo">
          <p class="pResult" v-show="mostraEncarggo">Aliquota Terceiros:</p>
          <input type="text" class="inputResult" v-show="mostraEncarggo" :value="raliquotaTerce" disabled>
          <p class="pResult"><b>Custo Funcionário (Total):</b></p>
          <input type="text" class="inputResult" :value="total" disabled>
        </div>
      </div>
      <b-modal ref="my-modal" class="sel" size="lg">
        <p>CNAE/Descrição pesquisada: <b>{{ txtCnae }}</b></p>
        <div style="max-height:500px; overflow: auto;">
          <table>
            <tr>
              <td>CNAE</td>
              <td>Descrição</td>
              <td></td>
            </tr>
            <tr v-for="(n, a) in cnaes" :key="a">
              <td style="width:90px;">{{ n.cnae }}</td>
              <td>{{ n.descricao }}</td>
              <td style="width: 110px; text-align;"><button @click="selecionar(n)">Selecionar</button></td>
            </tr>
          </table>
        </div>
      </b-modal>
      <b-modal ref="my-moda" class="sel" size="lg">
        <p>CNAE selecionado: <b>{{ cnaeSlect }}</b></p>
        <div style="max-height:500px; overflow: auto;">
          <table>
            <tr>
              <td>Observação</td>
              <td>RAT</td>
              <td>Alíquota Terceiros</td>
              <td></td>
            </tr>
            <tr v-for="(n, a) in cnaes" :key="a">
              <td>{{ n.obs }}</td>
              <td style="width:70px;">{{ n.rat }}</td>
              <td>{{ n.aliquotaTerceiros }}</td>
              <td style="width: 80px; text-align;"><button @click="selecionar1(n)">Selecionar</button></td>
            </tr>
          </table>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import services from '../services/services.js'
import topOp from '../shared/topOp.vue';
import { Money } from 'v-money';
export default {
  components: {
    'topOp': topOp,
    Money
  },
  data() {
    return {
      raliquotaTerce: '',
      rrat: '',
      rcpp: '',
      cnaeSlect: '',
      txtAliquota: '',
      txtRat: '',
      cnaes: [],
      erro: '',
      spiner: false,
      spiner2: false,
      disabled: false,
      txtCnae: '',
      rat: false,
      cnae: false,
      aliquota: false,
      total: '',
      rfgts13Ferias: '',
      rfgts: '',
      rumTercoFerias: '',
      rferias: '',
      rvalor13Salario: '',
      outrosBeneficios: '',
      rinss13Ferias: '',
      rinss: '',
      rplanoSaude: '',
      rvaleRefeicao: '',
      rdescontoValeTransporte: '',
      rvaleTransporte: '',
      resultadoValorSalario: '',
      salarioMensal: 0,
      valeTrans: 0,
      valeRefei: 0,
      mostraEncarggo: true,
      planoSaude: 0,
      outroBene: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      resultado: {}
    }
  },
  computed: {

  },
  methods: {
    async selecionar1(cnae) {
      console.log(cnae)
      this.txtAliquota = cnae.aliquotaTerceiros
      this.txtRat = cnae.rat
      this.$refs['my-moda'].hide()
    },
    async selecionar(cnae) {
      this.$refs['my-modal'].hide()
      this.$refs['my-moda'].show()
      console.log(cnae)
      this.txtCnae = cnae.cnae
      this.cnaeSlect = cnae.cnae
      this.cnaes = await services.getCnaeRp(cnae.idCNAE)
    },
    async buscarCnae() {
      this.spiner2 = true
      let ok = this.txtCnae
      let regex1 = RegExp('/')
      let regex2 = RegExp('-')
      console.log(regex1.test(ok))
      if (regex1.test(ok)) {
        ok = ok.replace("/", "")
      }
      if (regex2.test(ok)) {
        ok = ok.replace("-", "")
      }
      this.cnaes = await services.getCnae(ok)
      this.$refs['my-modal'].show()
      this.spiner2 = false
    },
    regimeTributarioOp() {
      let regimeTributario = document.getElementById('motivoTermino').selectedOptions[0].value
      this.txtAliquota = ''
      this.txtRat = ''
      this.txtCnae = ''
      switch (regimeTributario) {
        case "1":
          this.cnae = false
          break;
        case "2":
          this.cnae = true
          this.rat = true
          this.aliquota = false
          break;
        case "3":
          this.cnae = true
          this.rat = true
          this.aliquota = true
          break
      }
    },
    limpar() {
      this.txtAliquota = ''
      this.txtCnae = ''
      this.txtRat = ''
      this.salarioMensal = ''
      this.valeTrans = ''
      this.valeRefei = ''
      this.planoSaude = ''
      this.outroBene = ''
      this.rfgts13Ferias = ''
      this.rfgts = ''
      this.rumTercoFerias = ''
      this.rferias = ''
      this.rvalor13Salario = ''
      this.outrosBeneficios = ''
      this.rinss13Ferias = ''
      this.rinss = ''
      this.rplanoSaude = ''
      this.rvaleRefeicao = ''
      this.rdescontoValeTransporte = ''
      this.rvaleTransporte = ''
      this.resultadoValorSalario = ''
    },
    async calcular() {
      this.disabled = true;
      this.spiner = true;
      let regimeTributario = document.getElementById('motivoTermino').selectedOptions[0].value
      let a = this.txtAliquota
      let regex1 = RegExp(',')
      let regex2 = RegExp('%')
      console.log(regex1.test(a))
      if (regex1.test(a)) {
        a = a.replace(",", ".")
      }
      if (regex2.test(a)) {
        a = a.replace("%", "")
      }
      let obj = {
        "regimeTributario": parseInt(regimeTributario),
        "salarioMensal": this.salarioMensal,
        "valeTransporte": this.valeTrans,
        "valeRefeicao": this.valeRefei,
        "planoSaude": this.planoSaude,
        "outrosBeneficios": this.outroBene,
        "aliquotas":
        {
          "rat": this.txtRat.trim() == 'Não há' ? 0 : parseInt(this.txtRat),
          "aliquotaTerceiros": parseFloat(a)
        }

      }
      console.log(obj)
      this.resultado = await services.getCalcularCusto(obj)
      this.rfgts13Ferias = this.resultado.fgtS13Ferias
      this.rfgts = this.resultado.fgts
      this.rumTercoFerias = this.resultado.umTercoFerias
      this.rferias = this.resultado.ferias
      this.rvalor13Salario = this.resultado.valor13Salario
      this.outrosBeneficios = this.resultado.outrosBeneficios
      this.rinss13Ferias = this.resultado.insS13Ferias
      this.rinss = this.resultado.inss
      this.rplanoSaude = this.resultado.planoSaude
      this.rvaleRefeicao = this.resultado.valeRefeicao
      this.rdescontoValeTransporte = this.resultado.descontoValeTransporte
      this.rvaleTransporte = this.resultado.valeTransporte
      this.resultadoValorSalario = this.resultado.salario
      this.total = this.resultado.custoFuncionario
      this.raliquotaTerce = this.resultado.encargosSociais.aliquotaTerceiros
      this.rrat = this.resultado.encargosSociais.rat
      this.mostraEncarggo = this.resultado.mostrarEncargos
      this.rcpp = this.resultado.encargosSociais.cpp
      console.log(this.resultado)
      this.disabled = false;
      this.spiner = false
    }
  }
}

</script>

<style>
footer.modal-footer {
  display: none;
}

table>tr>td>button {
  background: #FF7835;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 3px;
  width: 77px;
  cursor: pointer;
}

table>tr>td>button:focus {
  outline: none;

}

div.modal-body {
  padding: 1.2rem !important;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-size: 13px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

#cnae fieldset {
  border: 2px #cccccc solid;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
}

legend {
  font-size: 16px !important;
  width: 60% !important;
}

#cnae {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#cnae p {
  text-align: left;
  margin: 0px;
}

#cnae button {
  background: #FF7835 0% 0% no-repeat padding-box;
  border-radius: 5px;
  color: #fff;
  margin-left: 15px;
  font-size: 14px;
  cursor: POINTER;
  width: 80px;
  border: none;
}

#cnae button:focus {
  outline: none;
}

#cnae>fieldset>div:nth-child(1) {
  display: flex
}

#cnae div>input:nth-child(1) {
  height: 35px;
  border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-radius: 10px;
  width: 100%;
  padding: 5px;
  font-size: 14px;
}

#cnae input:focus {
  outline: none;
}

input {
  border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
}

.inputResult {
  width: 370px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}

div.input-group-text {
  border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

.resultHorasExtras {
  width: 370px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}

.container-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center
}

.box {
  width: 360px;
  height: 45px;
  background: #fff;
}

.resultado {
  width: 407px;
  height: 45px;
  background: #fff;
}

.pResult {
  text-align: left;
  margin-bottom: 5px;
  margin-top: 10px;
  margin-left: 2px;
}

.calcular {
  float: right;
  background: #FF7835 0% 0% no-repeat padding-box;
  border: 2px solid #FF7835;
  border-radius: 5px;
  width: 170px;
  font-size: 21px;
  height: 48px;
  color: #fff;
  margin-top: -10px;
  font-weight: 600;
  cursor: pointer;
  font-style: italic;
}

.calcular:hover {
  background: #e64d00;
  border: 1px solid #e64d00;
}

input.formatacaoInput {
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}

.limpar {
  float: left;
  border: 2px solid #FF7835;
  border-radius: 5px;
  background: #fff;
  padding: 5px;
  font-weight: 500;
  font-size: 15px;
  width: 105px;
  cursor: pointer;
  font-style: italic;
}

input.formatacaoInput {
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}

.horasExtrasResultado {
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 30px;
  padding-top: 30px;
}

.horasExtras {
  padding-left: 110px;
  padding-right: 110px;
}

h3 {
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size: 26px;
}

.formAjuste {
  width: 370px;
  margin: 0px auto;
  position: relative;
  top: -40px;
}

#formAjuste2 {
  width: 370px;
  margin: 20px auto;
}

input {
  border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
}

@media only screen and (max-width: 767px) {
  .horasExtras {
    margin-top: 445px;
  }

  #formAjuste2 {
    width: 320px;
  }
}

@media only screen and (max-width: 767px) {
  #formAjuste2 {
    width: 300px;
    margin: 20px auto;
  }

  .horasExtras {
    padding-left: 80px;
  }
}

@media only screen and (max-width: 400px) {
  #formAjuste2 {
    width: 230px;
    margin: 20px auto;
  }

  .limpar {
    width: 88px;
  }

  .calcular {
    width: 126px;
    height: 37px;
    margin-top: 0px;
  }
}

@media only screen and (max-width: 490px) {
  .horasExtrasResultado {
    margin-top: 30px;
    padding-left: 40px;
    padding-right: 110px;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .resultHorasExtras {
    width: 300px;
    height: 45px;
    border-radius: 10px;
    padding-left: 10px;
  }

}
</style>


// WEBPACK FOOTER //
// src/screens/CustoFuncional.vue